import { CloudSun, Sparkles } from "lucide-react";
import { scoreColor } from "../lib/format";
import { dictionaries } from "../lib/i18n";
import type { UiLang, Optimization } from "../lib/types";

interface Props {
  optimization: Optimization;
  lang: UiLang;
}

/**
 * Forklarer hva værvindu-optimaliseringen faktisk gjorde. Poenget er at
 * brukeren skal kunne overprøve den: en rute som er flyttet på uten
 * begrunnelse er verre enn ingen optimalisering.
 */
export function OptimizationPanel({ optimization, lang }: Props) {
  const t = dictionaries[lang];
  const { applied, baselineScore, optimizedScore, explanation, swaps } = optimization;
  const gain = optimizedScore - baselineScore;

  return (
    <section className={`optimizer ${applied ? "" : "optimizer--neutral"}`}>
      <div className="optimizer-head">
        {applied ? <Sparkles size={13} /> : <CloudSun size={13} />}
        {applied ? t.optimizerApplied : t.optimizerConsidered}
      </div>

      {applied && (
        <div className="optimizer-score">
          <b style={{ color: scoreColor(optimizedScore) }}>{optimizedScore}</b>
          {gain > 0 && (
            <>
              <s>{baselineScore}</s>
              <span style={{ color: "var(--rust)", fontSize: 13, fontWeight: 700 }}>
                {t.optimizerGain(gain)}
              </span>
            </>
          )}
        </div>
      )}

      <ul className="optimizer-list">
        {explanation.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>

      {swaps.length > 0 && (
        <p style={{ fontSize: 12, color: "var(--fjord-muted)", margin: "14px 0 0", lineHeight: 1.6 }}>
          Bytter gjøres bare mellom stopp som ligger like ved hverandre langs korridoren, slik at
          reiseruten er den samme — det er bare hva du bruker dagen til som endres.
        </p>
      )}
    </section>
  );
}
